<template>
  <div id="TaskCenter" class="TaskCenter" @click="toTaskCenter()">
    <!-- <i class="iconfont el-icon-question"></i> -->
    任务中心
  </div>
</template>
<script>
export default {
  name: 'TaskCenter',
  methods: {
    toTaskCenter() {
      // TODO  任务中心入口
      // this.$message.error('开发中占位')
      this.$router.push({ name: 'Task' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .TaskCenter{
    margin-right: 25px;
    color: #a3a6ae;
    cursor: pointer;
    font-size: 14px;
  }
</style>
